'use strict';

window.CFC = window.CFC || {};
window.CFC.Contest = (function($) {
  function init() {
    $(document).on('gform_confirmation_loaded', function(){
      if (window.ga) {
        window.ga('send', 'event', 'Contest', 'Submission');
      }
    });    
  }
  
  $(init);
})(jQuery);  
